import React from 'react';
import Grid from '@mui/material/Grid2';
import './ExportSheet.css';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from "@mui/material";

function ExportSheet(props) {

    const players = props.players;

    function closeMenu() {
        props.closeMenu('exportSheet')
    }


    return (
        <div className='outerdiv2' style={{ marginTop: '50px' }}>
            <div className='innerdivborder2'>
                <div className='innerdiv2' >
                    <div><Button className='close-btn' variant="contained" onClick={closeMenu}><CloseIcon style={{ color: '#fad99a' }} /></Button> </div>
                    <div style={{ fontSize: '36px' }}>Import/Export Static</div>
                    <div style={{ fontSize: '24px' }}>
                        Import options
                    </div>
                    <div style={{ fontSize: '24px' }}>
                        Export options
                    </div>
                    WIP
                </div>
            </div>
        </div>
    );
}

export default ExportSheet;